var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1134 52.3048L54.4978 18.9203L49.8427 14.2652L16.4583 47.6497V52.3048H21.1134ZM23.8404 58.8881H9.875V44.9229L47.5152 7.28248C48.8009 5.99699 50.8849 5.99699 52.1703 7.28248L61.4808 16.5927C62.7662 17.8782 62.7662 19.9623 61.4808 21.2478L23.8404 58.8881ZM9.875 65.4715H69.125V72.0548H9.875V65.4715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.149d611c17ad820401ab82255a628ccb.svg";
export { ForwardRef as ReactComponent };